export const BUYBACK_QUOTES_FETCH_INTERVAL = 1000

export const BUYBACK_QUOTES_FETCH_TIMEOUT = 20000

export const MODAL_NAMES = {
  SEE_MORE_MARGIN: 'SEE_MORE_MARGIN',
  SEE_MORE_AVERAGE_SELLING_PRICE: 'SEE_MORE_AVERAGE_SELLING_PRICE',
}
